import BlogNavigation from './blog-navigation';
import ShopNavigation from './shop-navigation';

export default class Navigation {
  initializeEventListeners = () => {
    const { classList } = document.body;

    if (classList.contains('blog') || classList.contains('article')) {
      (new BlogNavigation()).initializeEventListeners();
    } else {
      (new ShopNavigation()).initializeEventListeners();
    }
  };
}
